import React from "react";
import { Form, Input, Row, Col, Space, Radio, Divider } from "antd";
import { RaceRadioGroup } from "../../../../components/GlobalComponents/GlobalComponents";

const { TextArea } = Input;

// Constants
const ETHNICITY_OPTIONS = [
  { value: "hispanic", label: "Hispanic or Latino" },
  { value: "notHispanic", label: "Not Hispanic or Latino" },
  { value: "decline", label: "Decline to specify" },
  { value: "notAsked", label: "Provider didn't ask" },
];

const DemographicsSection = () => {
  return (
    <div className="p-5 rounded-b-lg border-[1px]">
      <Row gutter={16}>
        <Col span={12} sm={24} md={12} lg={12}>
          <Form.Item name="race" label="Specify Race">
            <RaceRadioGroup />
          </Form.Item>

          <Row gutter={16}>
            <Col
              span={16}
              sm={24}
              md={24}
              lg={16}
              className="flex flex-col"
            >
              <Form.Item label="Religion" name="religion">
                <Input placeholder="Religion" maxLength={30} />
              </Form.Item>
              <Form.Item name="demographicsNotes" label="Notes">
                <TextArea
                  rows={4}
                  showCount
                  maxLength={300}
                  placeholder="Demographics Notes"
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col
          span={12}
          sm={24}
          md={12}
          lg={12}
          style={{
            borderLeft: "1px solid #e5e7eb",
            paddingLeft: "25px",
          }}
        >
          <Form.Item name="ethnicity" label="Ethnicity">
            <Radio.Group defaultValue="notAsked">
              <Space direction="vertical">
                {ETHNICITY_OPTIONS.map(option => (
                  <Radio key={option.value} value={option.value}>
                    {option.label}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Form.Item>
          <Divider />

          <Form.Item label="Preferred Languages" name="languages">
            <Input
              placeholder="Enter each language with comma ,"
              className="w-1/2"
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(DemographicsSection);
